import { render, staticRenderFns } from "./ObjectStoreBadge.vue?vue&type=template&id=bde2e840&scoped=true"
import script from "./ObjectStoreBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ObjectStoreBadge.vue?vue&type=style&index=0&id=bde2e840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde2e840",
  null
  
)

export default component.exports